import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { css } from "@filadd/phi-plus-styled-system/css";
import { Stack } from "@filadd/phi-plus-styled-system/jsx";
export const ReleaseOption = ({ label, courseExpires, location, locale, t, }) => {
    const localeDateStringFormat = courseExpires
        ? new Date(courseExpires).toLocaleDateString(locale)
        : null;
    return (_jsx("a", { href: location, children: _jsxs(Stack, { className: css({
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
            }), children: [_jsx("span", { className: css({
                        fontSize: "0.875rem",
                        color: "neutral.600",
                        textWrap: "wrap",
                    }), children: label }), localeDateStringFormat && (_jsx("p", { className: css({
                        fontSize: "0.75rem",
                        color: "neutral.400",
                    }), children: `${t("expires")}: ${localeDateStringFormat}` }))] }) }));
};
//# sourceMappingURL=ReleaseOption.js.map